import React, { ReactNode, useState } from "react";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";
import { Grid, MenuList, MenuItem } from "@material-ui/core";

import { makeStyles, useTheme } from "@material-ui/core/styles";

//
import { Footer } from "./Footer";
import { Header } from "./Header";

/*
 */
interface LayoutProps extends RouteComponentProps {
  children: ReactNode;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100vh",
    flexDirection: "column",
  },
  content: {
    flex: 1,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export const Layout = withRouter(function Layout(props: LayoutProps) {
  const classes = useStyles();

  const {
    children,
    location: { pathname },
  } = props;

  return (
    <div className={classes.root}>
      <Header />
      <Grid container direction="row" className={classes.content}>
        <Grid item xs={12} md={3}>
          <MenuList>
            <MenuItem component={Link} selected={pathname === "/"} to="/">
              About Stroke
            </MenuItem>
            <MenuList>
              <MenuItem
                className={classes.nested}
                component={Link}
                selected={pathname === "/sign-and-symptoms"}
                to="/sign-and-symptoms"
              >
                Sign of stroke
              </MenuItem>
              <MenuItem
                className={classes.nested}
                component={Link}
                selected={pathname === "/stroke-type"}
                to="/stroke-type"
              >
                Stroke type
              </MenuItem>
              <MenuItem
                className={classes.nested}
                component={Link}
                selected={pathname === "/stroke-treatment"}
                to="/stroke-treatment"
              >
                Treatment of ischemic stroke
              </MenuItem>
              <MenuItem className={classes.nested} component={Link} selected={pathname === "/tia-treatment"} to="/tia-treatment">
                TIA treatment 
              </MenuItem>
              <MenuItem className={classes.nested} component={Link} selected={pathname === "/iv-tpa-checklist"} to="/iv-tpa-checklist">
                IV tPA Screening Checklist
              </MenuItem>
              <MenuItem className={classes.nested} component={Link} selected={pathname === "/stroke-prevention"} to="/stroke-prevention">
                Stroke prevention 
              </MenuItem>
            </MenuList>
          </MenuList>
        </Grid>
        <Grid item xs={12} md={9}>
          {children}
        </Grid>
      </Grid>
      <Footer />
    </div>
  );
});
